import { graphql, useStaticQuery } from 'gatsby';

import { QueryFragments } from './queryFragments'; // eslint-disable-line

export const usePortalQuery = () => {
  const {
    sanityVenuePortal,
    sanityEventPortal,
    sanityBlogPortal,
    sanitySubscribePortal,
    sanitySearchPortal,
    sanityArtistPortal,
    sanityContactPortal,
  } = useStaticQuery(graphql`
    query {
      sanityVenuePortal {
        slug {
          current
        }
      }
      sanityEventPortal {
        slug {
          current
        }
      }
      sanityBlogPortal {
        slug {
          current
        }
      }
      sanitySubscribePortal {
        slug {
          current
        }
      }
      sanitySearchPortal {
        slug {
          current
        }
      }
      sanityArtistPortal {
        slug {
          current
        }
      }
      sanityContactPortal {
        slug {
          current
        }
      }
    }
  `);
  return (
    {
      venuePortal: sanityVenuePortal,
      eventPortal: sanityEventPortal,
      blogPortal: sanityBlogPortal,
      subscribePortal: sanitySubscribePortal,
      search: sanitySearchPortal,
      artistPortal: sanityArtistPortal,
      contactPortal: sanityContactPortal,
    } || {}
  );
};
